import { useState } from "react";
import { Link } from "react-router-dom";
import { ApexLogo } from "@/components/ApexLogo";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault(); setLoading(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-navy px-5" style={{ backgroundImage: "radial-gradient(circle at 20% 20%, #142234, #07111E)" }}>
      <div className="w-full max-w-md">
        <div className="mb-8 flex justify-center"><ApexLogo light /></div>
        <div className="rounded-2xl border border-navy-light bg-navy-surface p-8 shadow-2xl">
          <h1 className="font-serif text-2xl font-semibold text-white">Reset your password</h1>
          <p className="mt-1.5 text-sm text-slate-300">Enter your admin email and we'll send you a secure link to set a new password.</p>
          {sent ? (
            <p className="mt-4 rounded-lg border border-gold/30 bg-gold/10 p-3 text-sm text-slate-100" data-testid="forgot-confirmation">
              If that email is registered, a reset link has been sent. Please check your inbox (and spam folder).
            </p>
          ) : (
            <form onSubmit={submit} className="mt-5 space-y-4">
              <div>
                <Label htmlFor="email" className="text-slate-200">Email</Label>
                <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@apexpath.co.uk"
                  className="mt-1.5 bg-white text-slate-900 border-slate-300 placeholder:text-slate-400" required data-testid="forgot-email-input" />
              </div>
              {error && <p className="text-sm text-red-400">{error}</p>}
              <button type="submit" disabled={loading} className="btn-gold w-full disabled:opacity-60" data-testid="forgot-submit-btn">
                {loading ? "Sending…" : "Send reset link"}
              </button>
            </form>
          )}
          <Link to="/admin/login" className="mt-4 block text-center text-xs text-slate-400 hover:text-gold">← Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
